import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { MasterService } from '../services/master-mom.service';
import { ToastrUtilsService } from '../services/toastr-utils.service';
import { RSAHelper } from '../services/RSAHelper';
import { UserService } from '../services/user.service'
@Component({
  selector: 'app-cweditsection',
  templateUrl: './cweditsection.component.html',
  styleUrls: ['./cweditsection.component.scss'],
  providers: [ToastrUtilsService]
})
export class CweditsectionComponent implements OnInit {
  public MasterData: any;applnList:any[];sectionname:string="";
  user: any = [];useremail: string = "";userprofileInfo: any = [];
  sectionid:string="";public onClose: Subject<boolean>;
  constructor(private spinner: NgxSpinnerService,public RSAHelper: RSAHelper, private userService: UserService,private modalService: BsModalService,public masterservice:MasterService,private toastr: ToastrUtilsService) { }

  ngOnInit() {
    this.onClose = new Subject();
    this.user = this.userService.getUserInfo();
    this.checkuserInfo();

    if(this.MasterData!=null){      
      this.sectionname = this.MasterData.sectionName;
      this.sectionid = this.MasterData.sectionId;
      this.applnList=this.MasterData.applicationInfo;     
      this.applnList.forEach(function(e){
        if (typeof e === "object" ){
          e["selected"] = true
        }
      });
      ////this.applnList=this.applnList.map(x => Object.assign({}, this.applnList, {"selected": "true" }))
      //this.applnList.selected=true;
      //console.log(this.applnList);
    }
    
  }

  checkuserInfo() {
    try {
        //this.userprofileInfo = this.userService.getUserProfileInfo(this.useremail);
        this.userService.getUserProfileInfo(this.useremail).
            subscribe((result: any) => {
                var response;
                if (result.data == undefined) { response = result; this.userprofileInfo = response; }
                else { response = result.data; this.userprofileInfo = JSON.parse(this.userService.loadprofiledata(response)); }
                 
            });
    }
    catch (e) { console.log(e); }
}
  
  RemoveSelection()
  {
    debugger;
    for(var app of this.applnList)
    {
        app.selected=false;
    }
  }

  closeDialog() {
    this.modalService.hide(1);}

    Save() {      
      const selectedrows = this.applnList.filter(item => item.selected === true);
      try
      {
        debugger;
        const selectedApps = this.applnList.filter(item => item.selected == false);             
        var appID = '';
        for (var apps of selectedApps) 
        {      
          appID = appID + "," + apps.appid;      
        }
        if(appID.substring(0,1)==",") appID=appID.slice( 1 );
 
        const objTxnData={
        "sectionname":this.sectionname,
        "sectionid":this.sectionid,
        "employeeuno":1,
        "appid" : appID,
        "PRNumber":this.userprofileInfo.userPRnumber,
        "email":this.user.email
        
        }
       
        let encryptedioparam = this.RSAHelper.encryptWithPublicKey(JSON.stringify(objTxnData)); 
        this.masterservice.AddNewSection(JSON.stringify(encryptedioparam))

        
        .subscribe((result: any) => {
         const response = result.data;
          if (response.dictionary.IntResult > 0) {
            this.toastr.SuccessCustomMessage('Section added successfully.');
            this.onClose.next(true);
            this.modalService.hide(1);
          } else {
            if (response.dictionary.stringResult.includes('Violation of UNIQUE KEY constraint')) {
                this.toastr.ErrorCustomMessage('Section Already exists');
            } else {
                this.toastr.ErrorCustomMessage('There was an unexpected error.');
            }
        }
      },
        (error) => 
        {
            this.toastr.ErrorCustomMessage('There was an unexpected error.');
            this.spinner.hide();
        }
    ).add(() => {    
        this.spinner.hide();
    });
  }
    catch(err)
    {
      this.toastr.ErrorCustomMessage('There was an unexpected error.');
      this.spinner.hide();
    }          
  }
}
